import Hero from '../components/Hero';
import ContactForm from '../components/ContactForm';
//import ActionSection from '../components/ActionSection';
import WeeklyProgram from '../components/WeeklyProgram';
//import Testimonials from '../components/Testimonials';
import PhotoGallery from '../components/PhotoGallery';
import HorizontalVideoGallery from '../components/HorizontalVideoGallery';
//import CommunityEngagements from '../components/CommunityEngagments';
import WelcomeSection from '../components/WelcomeSection';
import ServiceTimes from '../components/ServiceTimes';
import MinistriesSection from '../components/MinistriesSection';
import SermonsSection from '../components/SermonsSection';
import DonationSection from '../components/DonationsSection';
import FaithStatements from '../components/FaithStatements';
import CallToAction from '../components/CallToAction';
import EventsSection from '../components/EventsSection'
import TestimonialsSection from '../components/TestimonialsSection'
import BackToTopButton from '../components/BackToTopButton'
import FooterSection from '../components/FooterSection'
import AboutUsSection from '../components/AboutUsSection';
import VideoListing from '../components/VideoListing';
import ChurchVolunteerOpportunites from '../components/VolunteerOpportunities';
import { Announcement } from '@mui/icons-material';
import FaqSection from '../components/FaqSection';










const Home = () => {

const church = JSON.parse(localStorage.getItem('church')) || {};

 
  return (
   <>
<section id="home"><Hero /></section>
<section id="welcome"><WelcomeSection /></section>
<section id="faith"><FaithStatements /></section>
<section id="cta"><CallToAction /></section>
<section id="services"><ServiceTimes /></section>
<section id="ministries"><MinistriesSection /></section>
<section id="announcements"><Announcement /></section>
<section id="events"><EventsSection /></section>
<section id="sermons"><SermonsSection /></section>
{church && church.donation_link && <section id="donate"><DonationSection /></section>}
<section id="testimonials"><TestimonialsSection /></section>
<section id="volunteer-opportunities"><ChurchVolunteerOpportunites /></section>
<section id="contact"><AboutUsSection/></section>
<section id="gallery"><PhotoGallery /></section>
{/*<section id="video-gallary"><HorizontalVideoGallery /></section>*/}
<section id="faqs"><FaqSection /></section>
<section id="contact"><ContactForm /></section>

   
    
   <BackToTopButton/>


   </>
  );
};

export default Home;
